// src/LuggageSolid.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var LuggageSolid_default = createIcon({
  displayName: "LuggageSolid",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.5 4.17035H14.5V5.33035H9.5V4.17035ZM17.26 5.33035H15.75V3.58035C15.7422 3.42031 15.6718 3.26975 15.5539 3.16122C15.436 3.0527 15.2801 2.99491 15.12 3.00035H8.88C8.71986 2.99491 8.564 3.0527 8.44612 3.16122C8.32824 3.26975 8.25779 3.42031 8.25 3.58035V5.33035H6.72V20.5004H17.28L17.26 5.33035ZM18.43 5.33035V20.5004H19.5C20.1412 20.5193 20.7639 20.2839 21.2322 19.8455C21.7005 19.4072 21.9765 18.8014 22 18.1604V7.66035C21.9765 7.02017 21.7002 6.41541 21.2316 5.97865C20.7629 5.54188 20.1402 5.30875 19.5 5.33035H18.43ZM5.5 5.33035H4.5C3.85975 5.30875 3.23706 5.54188 2.76843 5.97865C2.2998 6.41541 2.02346 7.02017 2 7.66035V18.1604C2.02348 18.8014 2.29948 19.4072 2.76781 19.8455C3.23614 20.2839 3.8588 20.5193 4.5 20.5004H5.5V5.33035Z",
        fill: "currentColor"
      })
    ]
  })
});

export {
  LuggageSolid_default
};
